(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bk-hp-bestsellers"] && !Shopify.designMode) return;
  try {
    
(function () {
  function bindAtc(form) {
    if (form.dataset.bkAtcReady === '1') return;
    form.dataset.bkAtcReady = '1';
    var btn = form.querySelector('[data-bk-atc-btn]');
    form.addEventListener('submit', function (e) {
      if (!btn) return;
      e.preventDefault();
      var defaultLabel = btn.getAttribute('data-default-label') || btn.textContent;
      var successLabel = btn.getAttribute('data-success-label') || 'Added';
      btn.disabled = true;
      btn.textContent = 'AddingÃ¢â‚¬Â¦';
      var fd = new FormData(form);
      fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) + 'cart/add.js', {
        method: 'POST',
        body: fd,
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
        .then(function () {
          btn.textContent = successLabel;
          btn.dataset.state = 'success';
          // Dispatch events the parent theme / cart drawer may listen for
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('theme:cart:add', { bubbles: true }));
          window.dispatchEvent(new CustomEvent('cart:updated'));
          // Update cart count bubble if present
          fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) + 'cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              document.querySelectorAll('[data-cart-count], .cart-count, cart-count').forEach(function (el) {
                el.textContent = cart.item_count;
                el.setAttribute('data-count', cart.item_count);
              });
            })
            .catch(function () {});
          setTimeout(function () {
            btn.textContent = defaultLabel;
            btn.removeAttribute('data-state');
            btn.disabled = false;
          }, 1800);
        })
        .catch(function () {
          // Fallback to native form submission
          btn.disabled = false;
          btn.textContent = defaultLabel;
          form.submit();
        });
    });
  }
  function init() {
    document.querySelectorAll('[data-bk-atc]').forEach(bindAtc);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bk-hp-hero-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  function bindAtc(form) {
    if (form.dataset.bkAtcReady === '1') return;
    form.dataset.bkAtcReady = '1';
    var btn = form.querySelector('[data-bk-atc-btn]');
    form.addEventListener('submit', function (e) {
      if (!btn) return;
      e.preventDefault();
      var defaultLabel = btn.getAttribute('data-default-label') || btn.textContent;
      var successLabel = btn.getAttribute('data-success-label') || 'Added';
      btn.disabled = true;
      btn.textContent = 'AddingÃ¢â‚¬Â¦';
      var fd = new FormData(form);
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        body: fd,
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
        .then(function () {
          btn.textContent = successLabel;
          btn.dataset.state = 'success';
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('theme:cart:add', { bubbles: true }));
          window.dispatchEvent(new CustomEvent('cart:updated'));
          fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              document.querySelectorAll('[data-cart-count], .cart-count, cart-count').forEach(function (el) {
                el.textContent = cart.item_count;
                el.setAttribute('data-count', cart.item_count);
              });
            })
            .catch(function () {});
          setTimeout(function () {
            btn.textContent = defaultLabel;
            btn.removeAttribute('data-state');
            btn.disabled = false;
          }, 1800);
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = defaultLabel;
          form.submit();
        });
    });
  }
  function init() {
    document.querySelectorAll('.bk-hp-hero-product [data-bk-atc]').forEach(bindAtc);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bk-hp-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initScrollIndicator(root) {
    var btn = root.querySelector('[data-bk-scroll]');
    if (!btn || btn.dataset.bkScrollReady === '1') return;
    btn.dataset.bkScrollReady = '1';
    btn.addEventListener('click', function () {
      var custom = btn.getAttribute('data-bk-scroll-target');
      var target = null;
      if (custom) {
        try { target = document.querySelector(custom); } catch (e) { target = null; }
      }
      if (!target) {
        // Default: scroll to the next sibling section element
        var hostSection = root.closest('.shopify-section') || root;
        var next = hostSection.nextElementSibling;
        while (next && (next.offsetHeight === 0 || next.getAttribute('hidden') !== null && next.hasAttribute('hidden'))) {
          next = next.nextElementSibling;
        }
        target = next;
      }
      if (target && typeof target.scrollIntoView === 'function') {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        window.scrollBy({ top: window.innerHeight * 0.9, behavior: 'smooth' });
      }
    });
  }

  function initHero(root) {
    initScrollIndicator(root);

    if (root.dataset.bkHeroReady === '1') return;
    root.dataset.bkHeroReady = '1';

    var slideCount = Number(root.dataset.bkSlideCount || 0);
    if (slideCount < 2) return; // single banner mode — no JS needed

    var slides = root.querySelectorAll('.bk-hp-hero__slide');
    var dots = root.querySelectorAll('[data-bk-dot]');
    var prev = root.querySelector('[data-bk-prev]');
    var next = root.querySelector('[data-bk-next]');
    var current = 0;
    var autoplayMs = Number(root.dataset.bkAutoplay || 0) * 1000;
    var timer = null;

    function go(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
      dots.forEach(function (dot, i) {
        var on = i === index;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      current = index;
    }

    function nextSlide() { go(current + 1); }
    function prevSlide() { go(current - 1); }

    if (prev) prev.addEventListener('click', function () { prevSlide(); restartAutoplay(); });
    if (next) next.addEventListener('click', function () { nextSlide(); restartAutoplay(); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        go(Number(dot.dataset.bkDot)); restartAutoplay();
      });
    });

    function startAutoplay() {
      if (!autoplayMs) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = setInterval(nextSlide, autoplayMs);
    }
    function stopAutoplay() {
      if (timer) { clearInterval(timer); timer = null; }
    }
    function restartAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);
    root.addEventListener('focusin', stopAutoplay);
    root.addEventListener('focusout', startAutoplay);

    // Touch swipe
    var touchStartX = null;
    root.addEventListener('touchstart', function (e) {
      if (e.touches && e.touches.length === 1) touchStartX = e.touches[0].clientX;
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (touchStartX == null) return;
      var endX = (e.changedTouches && e.changedTouches[0]) ? e.changedTouches[0].clientX : null;
      if (endX != null) {
        var dx = endX - touchStartX;
        if (Math.abs(dx) > 50) {
          if (dx < 0) { nextSlide(); } else { prevSlide(); }
          restartAutoplay();
        }
      }
      touchStartX = null;
    }, { passive: true });

    startAutoplay();
  }

  function bootstrap(scope) {
    (scope || document).querySelectorAll('[data-bk-hero]').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bootstrap(); });
  } else {
    bootstrap();
  }
  document.addEventListener('shopify:section:load', function (e) { bootstrap(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bk-hp-topbar"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initTopbar(el) {
    if (el.dataset.bkTopbarReady === '1') return;
    el.dataset.bkTopbarReady = '1';

    var count = parseInt(el.dataset.count, 10) || 0;
    if (count <= 1) return;

    var interval = parseInt(el.dataset.interval, 10) || 4000;
    var msgs = el.querySelectorAll('.bk-hp-topbar__msg');
    if (msgs.length <= 1) return;

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return;

    var idx = 0;
    var timer = null;

    function show(nextIdx) {
      msgs.forEach(function (m, i) {
        var active = i === nextIdx;
        m.classList.toggle('is-active', active);
        if (active) {
          m.removeAttribute('aria-hidden');
          if (m.tagName === 'A') m.removeAttribute('tabindex');
        } else {
          m.setAttribute('aria-hidden', 'true');
          if (m.tagName === 'A') m.setAttribute('tabindex', '-1');
        }
      });
    }

    function tick() {
      idx = (idx + 1) % msgs.length;
      show(idx);
    }

    function start() {
      stop();
      timer = window.setInterval(tick, interval);
    }
    function stop() {
      if (timer) { window.clearInterval(timer); timer = null; }
    }

    start();
    el.addEventListener('mouseenter', stop);
    el.addEventListener('mouseleave', start);
    el.addEventListener('focusin', stop);
    el.addEventListener('focusout', start);

    // Re-init in theme editor block selection
    document.addEventListener('shopify:section:load', function () {});
  }

  function bootstrap() {
    document.querySelectorAll('[data-bk-topbar]').forEach(initTopbar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector ? e.target.querySelector('[data-bk-topbar]') : null;
    if (el) initTopbar(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bk-hp-trending"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSoundToggle(btn) {
    if (btn.dataset.bkSoundReady === '1') return;
    btn.dataset.bkSoundReady = '1';
    var media = btn.closest('.bk-hp-trending__media');
    if (!media) return;
    var video = media.querySelector('[data-bk-video]');
    if (!video) return;
    btn.addEventListener('click', function () {
      var nextMuted = !video.muted ? true : false;
      video.muted = nextMuted;
      btn.setAttribute('aria-pressed', nextMuted ? 'false' : 'true');
      // Pause other videos when unmuting one to avoid overlapping audio
      if (!nextMuted) {
        document.querySelectorAll('.bk-hp-trending [data-bk-video]').forEach(function (v) {
          if (v !== video) { v.muted = true; }
        });
        document.querySelectorAll('.bk-hp-trending [data-bk-sound-toggle]').forEach(function (b) {
          if (b !== btn) { b.setAttribute('aria-pressed', 'false'); }
        });
      }
    });
  }

  function initAutoplay(video) {
    if (!video || video.dataset.bkAutoplayReady === '1') return;
    video.dataset.bkAutoplayReady = '1';
    // IntersectionObserver: play when in view, pause when out
    if (!('IntersectionObserver' in window)) {
      var p = video.play();
      if (p && typeof p.catch === 'function') { p.catch(function () {}); }
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var p = video.play();
          if (p && typeof p.catch === 'function') { p.catch(function () {}); }
        } else {
          video.pause();
        }
      });
    }, { threshold: 0.5 });
    io.observe(video);
  }

  function getSectionInnerHTML(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var node = doc.querySelector(selector);
    return node ? node.innerHTML : '';
  }

  function refreshEurusSections(parsedState) {
    // Eurus exposes the sections to re-render via Alpine.store('xCartHelper').
    // After a successful add we patch each section's innerHTML in place so
    // the cart drawer, mini cart, cart icon bubble and free-shipping bar
    // all reflect the new state without a full page reload.
    if (!window.Alpine) return;
    var helper = window.Alpine.store && window.Alpine.store('xCartHelper');
    if (!helper || typeof helper.getSectionsToRender !== 'function') return;
    var sections = helper.getSectionsToRender();
    if (!sections || !parsedState || !parsedState.sections) return;
    sections.forEach(function (section) {
      var el = document.querySelector(section.selector);
      if (el && parsedState.sections[section.id]) {
        try {
          el.innerHTML = getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        } catch (e) { /* swallow */ }
      }
    });
    // Update the bubble count from the freshly rendered DOM.
    var bubble = document.querySelector('#cart-icon-bubble span');
    if (bubble) {
      var n = parseInt(bubble.innerHTML, 10);
      if (!isNaN(n)) { helper.currentItemCount = n; }
    } else if (typeof parsedState.item_count === 'number') {
      helper.currentItemCount = parsedState.item_count;
    }
  }

  function openEurusMiniCart() {
    if (!window.Alpine || !window.Alpine.store) return false;
    var miniCart = window.Alpine.store('xMiniCart');
    if (miniCart && typeof miniCart.openCart === 'function') {
      miniCart.openCart();
      return true;
    }
    return false;
  }

  function initAtc(btn) {
    if (btn.dataset.bkAtcReady === '1') return;
    btn.dataset.bkAtcReady = '1';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var variantId = btn.getAttribute('data-variant-id');
      var fallbackUrl = btn.getAttribute('data-product-url');
      if (!variantId || variantId === '0') {
        if (fallbackUrl) { window.location.href = fallbackUrl; }
        return;
      }
      if (btn.getAttribute('data-bk-state') === 'loading') return;
      btn.setAttribute('data-bk-state', 'loading');

      // Match Eurus's product-cart.js payload: single item, with `sections`
      // so the drawer can be patched in place from the response.
      var sectionsToRender = [];
      if (window.Alpine && window.Alpine.store) {
        var helper = window.Alpine.store('xCartHelper');
        if (helper && typeof helper.getSectionsToRender === 'function') {
          sectionsToRender = helper.getSectionsToRender().map(function (s) { return s.id; });
        }
      }

      var rootRoute = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      fetch(rootRoute + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: 1,
          sections: sectionsToRender,
          sections_url: window.location.pathname
        })
      })
        .then(function (r) {
          if (!r.ok) {
            return r.json().then(function (err) {
              throw new Error((err && (err.description || err.message)) || ('Add to cart failed: ' + r.status));
            }).catch(function () { throw new Error('Add to cart failed: ' + r.status); });
          }
          return r.json();
        })
        .then(function (parsedState) {
          btn.setAttribute('data-bk-state', 'done');
          refreshEurusSections(parsedState);
          // Notify other Eurus listeners (free-shipping bar etc.)
          document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
          // Open the Eurus mini-cart drawer; fall back to clicking the cart
          // icon if the Alpine store isn't available.
          setTimeout(function () {
            if (!openEurusMiniCart()) {
              var cartIcon = document.querySelector('#cart-icon, [data-cart-icon], .header__icon--cart');
              if (cartIcon && typeof cartIcon.click === 'function') { cartIcon.click(); }
            }
          }, 200);
          // Reset visual state after 2.5s so the button is usable again.
          setTimeout(function () {
            if (btn.getAttribute('data-bk-state') === 'done') {
              btn.removeAttribute('data-bk-state');
            }
          }, 2500);
        })
        .catch(function (err) {
          console.error('[bk-hp-trending] ATC failed:', err);
          btn.removeAttribute('data-bk-state');
          // Visible error flash so the user knows the click registered.
          btn.setAttribute('data-bk-state', 'error');
          setTimeout(function () { btn.removeAttribute('data-bk-state'); }, 1800);
        });
    });
  }

  function bootstrap(root) {
    var scope = root || document;
    scope.querySelectorAll('.bk-hp-trending [data-bk-sound-toggle]').forEach(initSoundToggle);
    scope.querySelectorAll('.bk-hp-trending [data-bk-video][autoplay]').forEach(initAutoplay);
    scope.querySelectorAll('.bk-hp-trending [data-bk-atc]').forEach(initAtc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bootstrap(); });
  } else {
    bootstrap();
  }
  document.addEventListener('shopify:section:load', function (e) { bootstrap(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
